import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { CheckboxInputStateContext } from '../../utils/InputStateContext';
import { Icon, } from '../Icon';
const iconSizes = {
    medium: 'small',
    small: 'extraSmall',
};
const defaultProps = {
    checked: false,
    disabled: false,
    shape: 'square',
    size: 'medium',
};
const CheckboxIcon = ({ checked = defaultProps.checked, disabled = defaultProps.disabled, shape = defaultProps.shape, size = defaultProps.size, }) => {
    const { isFocused, isHovering, } = useContext(CheckboxInputStateContext);
    const checkboxStyles = useMemo(() => (css `
        ${styleUtils.flexCenter}
        ${styleUtils.transition('all')}
        background-color: ${checked ? theme.colors.gray700 : theme.colors.gray100};
        border-radius: ${theme.borderRadiusDefault};
        border-style: solid;
        border-color: ${theme.colors.gray500};
        border-width: ${styleUtils.rem(1)};
        color: ${disabled ? theme.colors.gray500 : theme.colors.gray100};
        flex-shrink: 0;
        height: ${theme.spacing.x6};
        width: ${theme.spacing.x6};
        ${shape === 'circle' && css `
          border-radius: 100%;
        `}
        ${isHovering && css `
          border-color: ${theme.colors.gray600};
        `}
        ${checked && css `
          border-color: ${theme.colors.gray700};
        `}
        ${disabled && css `
          background-color: ${theme.colors.gray200};
          border-color: ${theme.colors.gray400};
        `}
        ${size === 'small' && css `
          height: ${theme.spacing.x4};
          width: ${theme.spacing.x4};
        `}
        ${isFocused && css `
          ${styleUtils.focusVisibleStyles};
        `}
      `), [
        checked,
        disabled,
        isFocused,
        isHovering,
        shape,
        size,
    ]);
    return (_jsx("span", Object.assign({ "aria-hidden": "true", css: checkboxStyles }, { children: checked && (_jsx(Icon, { size: iconSizes[size], type: "check" })) })));
};
const MemoizedCheckboxIcon = memo(CheckboxIcon);
export { MemoizedCheckboxIcon as CheckboxIcon };
// MC-1068 Temporary hack for Storybook.
export default CheckboxIcon;
